import React, {useState, useEffect } from "react";
import {
  Spinner
} from "reactstrap";

import classnames from "classnames";


export default function SpinnerLoader() {
	
	return (
		<div className="text-center">
		  <i className="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
		</div>
	);
}


// WEBPACK FOOTER //
// ./src/views/Components/SpinnerLoader/SpinnerLoader.js